import { Component, OnInit } from '@angular/core';
import { Adal5Service } from 'adal-angular5';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { LocalCacheService } from '../../../../core/local-cache/local-cache.service';
import { SharedCallsService } from '../../../../shared/services/shared-calls.service';

declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public isCollapsed = true;
  profileDdToggle = false;
  userName: string;
  emailId: string;
  persistlockId: string;

  constructor(private adalService: Adal5Service,
    public router: Router,
    private storage: LocalCacheService,
    private sharedCallsService: SharedCallsService) {
    router = this.router;
  }

  ngOnInit() {
    this.router = this.router;
  }
  get initials(): string {

    if (this.isLoggedIn) {
      const first = this.adalService.userInfo.profile.given_name[0].toUpperCase();
      const second = this.adalService.userInfo.profile.family_name[0].toUpperCase();
      this.userName = this.adalService.userInfo.profile.family_name + ', ' + this.adalService.userInfo.profile.given_name;
      this.emailId = this.storage.fetchData('loggedEmailId');

      return first + second;
    }
  }
  logout() {
    this.persistlockId = this.storage.fetchData('lockId');
    if (this.persistlockId) {
      this.sharedCallsService.deleteLock(this.persistlockId).subscribe((data: any) => {

      });
    }
    this.adalService.clearCache();
    this.storage.clearAll();
    this.adalService.logOut();
  }

  profileDropDownToggle() {

    this.profileDdToggle = !this.profileDdToggle;
    // closeprofile dropdown if clicked outside
    Observable.fromEvent(window, 'click')
      .subscribe((event: any) => {
        if (event.target) {

          if (!event.target.matches('.rounded-circle a')
            && this.profileDdToggle === true) {
            this.profileDdToggle = false;
          } else if (event.target.matches('.rounded-circle .profile-dropdown-menu a')
            && this.profileDdToggle === true) {
            this.profileDdToggle = false;
          }
        }
      });
  }
  public get isLoggedIn() {

    return this.adalService.userInfo.authenticated;
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/components/shared/layout/header/header.component.ts